import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { RequestOptions, ResponseContentType } from '@angular/http';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private http : HttpClient
  ) { }

    getAll(searchParams){
      return this.http.get(`${environment.JlUrl}/user`,{params:searchParams});
    }

    get(id){
      return this.http.get(`${environment.JlUrl}/user/`+id);
    }

    edit(id,formData){
      return this.http.put(`${environment.JlUrl}/user/`+id,formData);
    }

    create(formData){
		return this.http.post(`${environment.JlUrl}/user`,formData);
	  }

    delete(id){
      return this.http.delete(`${environment.JlUrl}/user/`+id);
    }

    updateProfile(formData){
      return this.http.post(`${environment.JlUrl}/user/profile`,formData);
    }


}
